import { render } from "./PersonComponent.vue?vue&type=template&id=008f5f0a"
import script from "./PersonComponent.vue?vue&type=script&lang=js"
export * from "./PersonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__